import { AppBar, Container, Tab, Tabs, Grid2 } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { TabPanel, a11yProps } from "components/common/Tabs";
import { Paths } from "components/common/navigation";
import { statisticsStyles } from "components/statistics/styles";
import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

const useStyles = makeStyles(statisticsStyles);

function Home() {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();

    const isReviewsSelected = location.pathname === Paths.STATISTICS_USER;
    const isTags = location.pathname === Paths.STATISTICS_TAGS;
    const isFilm = location.pathname === Paths.STATISTICS_CATEGORIES;

    const [value, setValue] = React.useState(Paths.STATISTICS_USER);

    const handleChange = (event, newValue) => {
        navigate(newValue);
        setValue(newValue);
    };
    const menu = (
        <Paper className={classes.paperMenu}>
            <MenuList className={"atsNoLink"}>
                <Link to={Paths.STATISTICS_USER}>
                    <MenuItem className={isReviewsSelected && classes.menuItemSelected}> Reviews</MenuItem>
                </Link>
                <Link to={Paths.STATISTICS_TAGS}>
                    <MenuItem className={isTags && classes.menuItemSelected}> Tags</MenuItem>
                </Link>
                <Link to={Paths.STATISTICS_CATEGORIES}>
                    <MenuItem className={isFilm && classes.menuItemSelected}> Rating Categories </MenuItem>
                </Link>
            </MenuList>
        </Paper>
    );
    return (
        (<Container maxWidth={"xl"} className={`atsGlobalContainer ${classes.root}`}>
                <Grid2 container sx={{ display: {sm: "none", xs: "none", md: "none", xl: "flex", lg: "flex"}}}>
                    <Grid2
                        size={{
                            xl: 2,
                            lg: 2,
                            md: 3
                        }}>
                        {menu}
                    </Grid2>
                    <Grid2
                        size={{
                            xl: 10,
                            lg: 10,
                            md: 9
                        }}>
                        <Outlet />
                    </Grid2>
                </Grid2>

            <Grid2 sx={{ display: {sm: "block", xs: "block", md: "block", xl: "none", lg: "none"}}}>
                <AppBar
                    color="default"
                    position={"relative"}
                    style={{
                        zIndex: "10",
                    }}
                >
                    <Tabs value={value} onChange={handleChange} aria-label="wrapped label tabs example">
                        <Tab value={Paths.STATISTICS_USER} label="Review" {...a11yProps(Paths.STATISTICS_USER)} />
                        <Tab value={Paths.STATISTICS_TAGS} label="Item Tags" {...a11yProps(Paths.STATISTICS_TAGS)} />
                        <Tab value={Paths.STATISTICS_CATEGORIES} label="Film release Categories" {...a11yProps(Paths.STATISTICS_CATEGORIES)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={Paths.STATISTICS_USER}/>
                <TabPanel value={value} index={Paths.STATISTICS_TAGS}/>
                <TabPanel value={value} index={Paths.STATISTICS_CATEGORIES}/>
            </Grid2>
        </Container>)
    );
}

export default Home;
